import React from 'react'
import LazySection from '../LazySection'

import styles from './blockfive.module.css'
function BlockFive({planetaryArchitypesRef, theMercuryArchetype, theVenusArchetype, theMarsArchetype, theJupiterArchetype, theSaturnArchetype }) {
    return (
        <>
            <LazySection >

                <div className={`${styles.mercury_archetype_Block1} `} >

                    <div className={styles.common_width}>

                        {/* <div className={styles.column}>
                            <div className={`${styles.col12} ${styles.bgifive}`}>
                                <h2>
                                    The Mercury Archetype - Divine Intelligence
                                </h2>
                            </div>
                        </div> */}




                        <div className={`${styles.mercury_archetype_Block1_Innr} ${styles.flx_wrpr} ${styles.flx_row} `}>

                            <div className={styles.school_ritual_txt_box_wrpr}>
                                <h2 ref={theMercuryArchetype}>mercury invocation</h2>
                                <h6>The Mercury Archetype - Divine Intelligence</h6>
                                <h3>1. Enhanced Communication Skills</h3>

                                <p>By actively banishing traits like communication misunderstandings, nervousness, and deceit, you clear the path for more honest and effective communication. This purification allows for a clearer
                                    transmission and reception of ideas, crucial for personal and professional relationships.
                                </p>

                                <h3>2. Intellectual Acuity and Eloquence</h3>


                                <p>Invoking Mercury's qualities such as clarity of thought, eloquence, and intellectual acuity sharpens your mind and enhances your ability to articulate ideas. As these traits are strengthened, you find it easier to convey complex thoughts and engage in meaningful dialogues that reflect deep understanding and insight.</p>

                                <h3>3. Adaptability and Continuous Learning</h3>


                                <p>Mercury influences daily activities that involve education, travel, and engaging with new technologies and ideas. By continuously seeking new information and engaging in intellectually stimulating activities like writing and solving puzzles, you foster adaptability and a keen ability to navigate and assimilate various streams of knowledge.

                                </p>


                            </div>

                            <div className={styles.school_ritual_img_box_wrpr}>

                                <img
                                    className={styles.school_ritual_img1}
                                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/saturn-jupiter-venus-mars-mercury-img/mercury_img_1.webp" alt='Image'
                                />

                            </div>

                        </div>





                    </div>

                </div>
            </LazySection>

            <LazySection >

                <div className={`${styles.mercury_archetype_Block2} `} >

                    <div className={styles.common_width}>

                        <div className={`${styles.mercury_archetype_Block2_Innr} ${styles.flx_wrpr} `}>

                            <div className={styles.school_ritual_txt_box_wrpr}>
                                <h3>4.  Effective Problem-Solving</h3>

                                <p>With an increased focus on activities that require intellectual agility, you enhance your
                                    problem-solving skills. This ability is directly influenced by Mercury’s domain over logical analysis and strategic thinking, allowing you to approach challenges with innovative solutions.
                                </p>

                                <h3>5. Integration of Knowledge and Ideas</h3>


                                <p>As you invoke Mercury’s influence in communication and intellectual pursuits, you become a conduit for integrating and disseminating knowledge. This role not only benefits your personal growth but also contributes to the collective by bridging gaps in understanding and facilitating the exchange of ideas.
                                </p>

                                <p>Through this ritual praxis, you refine your ability to perceive and integrate the archetypal power of
                                    Mercury directly. This integration results in a transformative effect on your cognitive functions,
                                    enhancing your communication skills, intellectual adaptability, and effectiveness in dealing with
                                    information and technology, thereby fostering a more informed and eloquent presence in all
                                    areas of life.
                                </p>




                            </div>

                            <div className={styles.school_ritual_img_box_wrpr}>

                                <img
                                    className={styles.school_ritual_img1}
                                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/saturn-jupiter-venus-mars-mercury-img/mercury_img_2.webp" alt='Image'
                                />

                            </div>

                        </div>





                    </div>

                </div>
            </LazySection>

            <LazySection >

                <div className={`${styles.mercury_archetype_Block3} `} >

                    <div className={styles.common_width}>

                        <div className={`${styles.mercury_archetype_Block3_Innr} ${styles.flx_wrpr} ${styles.flx_row}`}>

                            <div className={styles.school_ritual_txt_box_wrpr}>
                                <h3>Ritual Praxis of the Planetary Intelligence</h3>

                                <p>Once completing the opening of the gates of air, staying still and centralized within the ritual space, focusing on the infinite center of being and the spherical self boundary as the total immortal and
                                    infinite self, make the gesture of Mercury. Hold for one to three full breaths then make the
                                    pronouncement and resonate the Divine Name of the Planetary Intelligence.

                                </p>

                                <p><span>Pronouncement: "In nomine Mercurii, custodis commercii et eloquentiae,"</span></p>

                                <p><span>Translation: "In the name of Mercurius, guardian of commerce and eloquence,"</span></p>

                                <p><span>Phonetics: "In noh-mee-nay Mer-koo-ree-ee, kus-toh-dees koh-mehr-kee-ee et eh-loh-kwen-tee-eye,"</span></p>

                                <div className={styles.clippathsec}>
                                    <p>Resonate Divine Name <span>(1 to 3 times)</span></p>
                                </div>

                                <p style={{ fontWeight: "500" }}><span className={styles.color_white}>Mercury / Latin:</span> <span>Mercurius (mer-KOOR-ee-oos) - meeeeer-KOOOOOR-eeee-oooos</span></p>

                                <p>If banishing, focus on a purification of Mercury’s Archetype within the personal psychology and energetic being. If invoking, focus on the unity between the self and the self boundary as a total unity allowing the Divine Intelligence of the Higher Being of Mercury to possess and transform.  Hold the sign of silence for at least three full breaths afterward focusing on the purity of the Archetype if Banishing or allowing the Planetary Intelligence to fully embody if Invoking. 
                                </p>




                            </div>

                            <div className={styles.school_ritual_img_box_wrpr}>

                                <img
                                    className={styles.school_ritual_img1}
                                    src="/image/mercury_img_3_new.webp" alt='Image'
                                />

                            </div>

                        </div>





                    </div>

                </div>
            </LazySection>

            <LazySection >

                <div className={`${styles.venus_archetype_Block} `} ref={theVenusArchetype} >

                    <div className={styles.common_width}>

                        {/* <div className={styles.column}>
                            <div className={`${styles.col12} ${styles.bgifive}`}>
                                <h2>
                                    The Venus Archetype - Divine Intelligence
                                </h2>
                            </div>
                        </div> */}




                        <div className={`${styles.venus_archetype_Block1_Innr} ${styles.flx_wrpr}`}>

                            <div className={styles.school_ritual_txt_box_wrpr}>
                                <h2>Venus Invocation</h2>
                                <h6>The Venus Archetype - Divine Intelligence</h6>
                                <h3>1. Enhanced Self-Esteem and Independence</h3>

                                <p>By consciously banishing traits like dependency and indulgence, you cultivate a stronger sense of self-worth and independence. This purification allows you to love and value yourself, laying a solid foundation for healthier relationships and personal choices that reflect your true worth.
                                </p>

                                <h3>2. Cultivation of Love and Harmony</h3>

                                <p>Invoking Venus's qualities such as love, beauty, and harmony enhances your ability to connect deeply with others and create a life that resonates with these values. As you integrate these traits, your
                                    personal and professional relationships become more meaningful and harmonious.</p>

                                <h3>3. Artistic Expression and Appreciation</h3>

                                <p>Venus influences daily activities that involve artistic endeavors and the appreciation of beauty. By engaging in creating or appreciating art, you tap into Venus’s energy of creativity and aesthetic appreciation, enriching your life and expanding your perspectives on beauty and expression.</p>


                            </div>

                            <div className={styles.school_ritual_img_box_wrpr}>

                                <img
                                    className={styles.school_ritual_img1}
                                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/saturn-jupiter-venus-mars-mercury-img/venus_img_1.webp" alt='Image'
                                />

                            </div>

                        </div>


                        <div className={`${styles.venus_archetype_Block2_Innr} ${styles.flx_wrpr} ${styles.flx_row}`}>

                            <div className={styles.school_ritual_txt_box_wrpr}>
                                <h3>4. Attraction and Romantic Relationships</h3>

                                <p>Cultivating personal relationships and engaging in romantic encounters that are influenced by Venus enhances your capacity for love and attraction. This practice allows you to experience and express love more fully, fostering deeper connections that are both fulfilling and transformative.

                                </p>

                                <h3>5. Pleasure and Sensory Engagement</h3>

                                <p>By indulging in sensory experiences that bring pleasure, whether through fashion, cuisine, or nature, you embody Venus’s quality of finding joy in the physical world. This not only enhances your enjoyment of life but also deepens your appreciation for the world around you.
                                </p>

                                <p>Through this ritual praxis, you refine your ability to perceive and integrate the archetypal power of Venus directly. This integration results in a transformative effect on your emotional and aesthetic
                                    faculties, enhancing your relationships, artistic expression, and appreciation for life’s pleasures. This leads to a more balanced and beautiful existence, deeply aligned with Venus’s attributes of love,
                                    harmony, and beauty.</p>




                            </div>

                            <div className={styles.school_ritual_img_box_wrpr}>

                                <img
                                    className={styles.school_ritual_img1}
                                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/saturn-jupiter-venus-mars-mercury-img/venus_img_2.webp" alt='Image'
                                />

                            </div>

                        </div>

                        <div className={`${styles.venus_archetype_Block3_Innr} ${styles.flx_wrpr} `}>

                            <div className={styles.school_ritual_txt_box_wrpr}>
                                <h3>Ritual Praxis of the Planetary Intelligence</h3>

                                <p>Once completing the opening of the gates of earth, staying still and centralized within the ritual space, focusing on the infinite center of being and the spherical self boundary as the total immortal and
                                    infinite self, make the gesture of Venus. Hold for one to three full breaths then make the
                                    pronouncement and resonate the Divine Name of the Planetary Intelligence.

                                </p>

                                <p><span>Pronouncement: "In nomine Veneris, deae amoris et pulchritudinis,"</span>
                                </p>

                                <p><span>Translation: "In the name of Venus, goddess of love and beauty,"</span></p>

                                <p><span>Phonetics: "In noh-mee-nay Way-neh-rees, deh-eye ah-moh-rees et pool-kree-too-dee-nees,"</span></p>

                                <div className={styles.clippathsec}>
                                    <p>Resonate Divine Name <span>(1 to 3 times)</span></p>
                                </div>

                                <p style={{ fontWeight: "500" }}><span className={styles.color_white}>Venus / Latin: </span> <span>Venus (WAY-noos) (WAAAAAAYYYYYY-noooooosssssss)</span></p>

                                <p>If banishing, focus on a purification of Venus’s Archetype within the personal psychology and energetic being. If invoking, focus on the unity between the self and the self boundary as a total unity allowing the Divine Intelligence of the Higher Being of Venus to possess and transform.  Hold the sign of silence for at least three full breaths afterward focusing on the purity of the Archetype if Banishing or allowing the Planetary Intelligence to fully embody if Invoking.
                                </p>




                            </div>

                            <div className={styles.school_ritual_img_box_wrpr}>

                                <img
                                    className={styles.school_ritual_img1}
                                    src="/image/venus_img_3_new.webp" alt='Image'
                                />

                            </div>

                        </div>


                    </div>

                </div>
            </LazySection>

            <LazySection >

                <div className={`${styles.mars_archetype_Block1} `} >

                    <div className={styles.common_width}>

                        {/* <div className={styles.column}>
                            <div className={`${styles.col12} ${styles.bgifive}`}>
                                <h2>
                                    The Mars Archetype - Divine Intelligence
                                </h2>
                            </div>
                        </div> */}




                        <div className={`${styles.mars_archetype_Block1_Innr} ${styles.flx_wrpr} ${styles.flx_row} `}>

                            <div className={styles.school_ritual_txt_box_wrpr}>
                                <h2 ref={theMarsArchetype}>Mars Invocation</h2>
                                <h6>The Mars Archetype - Divine Intelligence</h6>
                                <h3>1. Controlled Aggression and Assertiveness</h3>

                                <p>By consciously banishing traits like aggression, conflict, impulsivity, and rashness, you cultivate a more controlled and constructive form of assertiveness. This purification allows you to approach challenges with calm determination rather than uncontrolled anger, enhancing your ability to achieve your goals without unnecessary conflict.

                                </p>

                                <h3>2. Enhanced Energy and Action</h3>


                                <p>Invoking Mars's qualities such as energy, action, and courage fuels your drive to initiate and complete projects. As these traits are strengthened, you find yourself more capable of taking decisive actions that reflect your passions and ambitions, effectively transforming ideas into reality.</p>

                                <h3>3. Courage and Protective Instincts</h3>


                                <p>Mars influences daily activities that involve physical courage and protective instincts. By engaging in competitive sports or activities that challenge your physical and mental limits, you harness Mars’s energy of bravery and protection, enhancing your ability to stand up for yourself and others.
                                </p>

                                <h3>4. Passion in Pursuits</h3>

                                <p>Taking initiative and engaging vigorously in projects or causes you believe in allows you to live passionately. This practice connects you deeply with Mars’s dynamic energy, driving you to pursue your goals with enthusiasm and relentless effort.
                                </p>

                                <h3>5. Assertive Leadership</h3>

                                <p>By standing up for your beliefs and defending others, you embody Mars’s qualities of leadership and advocacy. This not only impacts your personal growth but also inspires and motivates those around you, fostering a sense of solidarity and empowerment within your community.</p>

                                <p>Through this ritual praxis, you refine your ability to perceive and integrate the archetypal power of Mars directly. This integration results in a transformative effect on your personal dynamics, enhancing your assertiveness, courage, and energy. It encourages you to act boldly and protectively, leading to a more active and passionate engagement with the world around you.
                                </p>

                            </div>

                            <div className={styles.school_ritual_img_box_wrpr}>

                                <img
                                    className={styles.school_ritual_img1}
                                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/saturn-jupiter-venus-mars-mercury-img/mars_img_1.webp" alt='Image'
                                />

                            </div>

                        </div>





                    </div>

                </div>
            </LazySection>

            <LazySection >

                <div className={`${styles.mars_archetype_Block2} `} >

                    <div className={styles.common_width}>

                        <div className={`${styles.mars_archetype_Block2_Innr} ${styles.flx_wrpr} `}>

                            <div className={styles.school_ritual_txt_box_wrpr}>
                                <h3>Ritual Praxis of the Planetary Intelligence</h3>

                                <p>Once completing the opening of the gates of fire, staying still and centralized within the ritual space, focusing on the infinite center of being and the spherical self boundary as the total immortal and
                                    infinite self, make the gesture of Mars. Hold for one to three full breaths then make the
                                    pronouncement and resonate the Divine Name of the Planetary Intelligence.


                                </p>

                                <p><span>Pronouncement: "In nomine Martis, dei belli et actionis,"</span>

                                </p>

                                <p><span>Translation: "In the name of Mars, god of war and action,"</span></p>

                                <p><span>Phonetics: "In noh-mee-nay Mar-tees, day-ee beh-lee et ak-tee-oh-nees,"</span></p>

                                <div className={styles.clippathsec}>
                                    <p>Resonate Divine Name <span>(1 to 3 times)</span></p>
                                </div>

                                <p style={{ fontWeight: "500" }}><span className={styles.color_white}>Mars / Latin: </span> <span>Mars (Mahrss)  (Maaaaahhhrrrrrrrssrss)</span></p>

                                <p>If banishing, focus on a purification of Mar’s Archetype within the personal psychology and energetic being. If invoking, focus on the unity between the self and the self boundary as a total unity allowing the Divine Intelligence of the Higher Being of Mars to possess and transform.  Hold the sign of silence for at least three full breaths afterward focusing on the purity of the Archetype if Banishing or allowing the Planetary Intelligence to fully embody if Invoking.

                                </p>




                            </div>

                            <div className={styles.school_ritual_img_box_wrpr}>

                                <img
                                    className={styles.school_ritual_img1}
                                    src="/image/mars_img_2_new.webp" alt='Image'
                                />

                            </div>

                        </div>





                    </div>

                </div>
            </LazySection>

            <LazySection >

                <div className={`${styles.jupiter_archetype_Block1} `} >

                    <div className={styles.common_width}>

                        {/* <div className={styles.column}>
                            <div className={`${styles.col12} ${styles.bgifive}`}>
                                <h2>
                                    The Jupiter Archetype - Divine Intelligence
                                </h2>
                            </div>
                        </div> */}




                        <div className={`${styles.jupiter_archetype_Block1_Innr} ${styles.flx_wrpr} ${styles.flx_row} `}>

                            <div className={styles.school_ritual_txt_box_wrpr}>
                                <h2 ref={theJupiterArchetype}>Jupiter Invocation</h2>
                                <h6>The Jupiter Archetype - Divine Intelligence</h6>
                                <h3>1. Moderation and Humility</h3>

                                <p>By consciously banishing traits like excess, arrogance, and overindulgence, you foster a sense of moderation and humility. This purification process helps align your actions with wisdom rather than mere desire, ensuring that your pursuits are balanced and thoughtful.

                                </p>

                                <h3>2. Expansion of Knowledge and Wisdom</h3>


                                <p>Invoking Jupiter’s qualities such as growth, wisdom, and prosperity enhances your intellectual and spiritual pursuits. As these traits are strengthened, you find yourself more open to learning new things and exploring broader philosophical ideas, which in turn enrich your understanding of the world and your place within it.</p>

                                <h3>3. Optimism and Faith</h3>


                                <p>Jupiter influences daily activities that involve optimism and faith. By maintaining a positive outlook and trusting in the larger flow of life, you tap into Jupiter’s energy of hope and expansion. This not only sustains you through challenges but also opens you up to recognizing and seizing
                                    opportunities for growth.
                                </p>


                            </div>

                            <div className={styles.school_ritual_img_box_wrpr}>

                                <img
                                    className={styles.school_ritual_img1}
                                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/saturn-jupiter-venus-mars-mercury-img/jupiter_img_1.webp" alt='Image'
                                />

                            </div>

                        </div>





                    </div>

                </div>
            </LazySection>

            <LazySection >

                <div className={`${styles.jupiter_archetype_Block2} `} >

                    <div className={styles.common_width}>

                        <div className={`${styles.jupiter_archetype_Block2_Innr} ${styles.flx_wrpr} `}>

                            <div className={styles.school_ritual_txt_box_wrpr}>
                                <h3>4. Cultural and Spiritual Growth</h3>

                                <p>Engaging in travel, higher education, and cultural experiences allows you to embrace Jupiter’s
                                    qualities of expansion and learning. These activities enrich your life, broaden your horizons, and deepen your cultural and spiritual understanding, reflecting Jupiter’s role in promoting
                                    comprehensive growth.

                                </p>

                                <h3>5. Teaching and Sharing Knowledge</h3>


                                <p>By teaching or sharing what you have learned, you embody Jupiter’s attributes of generosity and
                                    enlightenment. This practice not only reinforces your own knowledge but also contributes to the growth and prosperity of others, spreading Jupiter’s beneficial influence further into your community.
                                </p>

                                <p>
                                    Through this ritual praxis, you refine your ability to perceive and integrate the archetypal power of
                                    Jupiter directly. This integration results in a transformative effect on your personal development,
                                    enhancing your wisdom, optimism, and capacity for growth. It encourages you to explore and expand in meaningful ways, leading to a richer, more enlightened engagement with the world around you.
                                </p>




                            </div>

                            <div className={styles.school_ritual_img_box_wrpr}>

                                <img
                                    className={styles.school_ritual_img1}
                                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/saturn-jupiter-venus-mars-mercury-img/jupiter_img_2.webp" alt='Image'
                                />

                                <img className={styles.abs_img1} src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/saturn-jupiter-venus-mars-mercury-img/jupiter_img_2_glow.webp" alt='Image' />

                            </div>

                        </div>





                    </div>

                </div>
            </LazySection>

            <LazySection >

                <div className={`${styles.jupiter_archetype_Block3} `} >

                    <div className={styles.common_width}>

                        <div className={`${styles.jupiter_archetype_Block3_Innr} ${styles.flx_wrpr} ${styles.flx_row}`}>

                            <div className={styles.school_ritual_txt_box_wrpr}>
                                <h3>Ritual Praxis of the Planetary Intelligence</h3>

                                <p>Once completing the opening of the gates of fire, staying still and centralized within the ritual space,
                                    focusing on the infinite center of being and the spherical self boundary as the total immortal and infinite self, make the gesture of Jupiter. Hold for one to three full breaths then make the pronouncement and resonate the Divine Name of the Planetary Intelligence.

                                </p>

                                <p><span>Pronouncement: "In nomine Iovis, patris sapientiae et abundantis fortunae,"</span> 

                                </p>

                                <p><span>Translation: "In the name of Iuppiter, father of wisdom and abundant fortune,"</span></p>

                                <p><span>Phonetics: "In noh-mee-nay Yoh-wees, pah-trees sah-pee-en-tee-eye et ah-bun-dahn-tees for-too-nee,"</span></p>

                                <div className={styles.clippathsec}>
                                    <p>Resonate Divine Name <span>(1 to 3 times)</span></p>
                                </div>

                                <p style={{ fontWeight: "500" }}><span className={styles.color_white}>Jupiter / Latin:  </span> <span>Iuppiter (yoo-PIP-ter) - yooooooo-PIIIIIIP-teeeerrrrr</span></p>

                                <p>If banishing, focus on a purification of Jupiter’s Archetype within the personal psychology and energetic being. If invoking, focus on the unity between the self and the self boundary as a total unity allowing the Divine Intelligence of the Higher Being of Jupiter to possess and transform.  Hold the sign of silence for at least three full breaths afterward focusing on the purity of the Archetype if Banishing or allowing the Planetary Intelligence to fully embody if Invoking.

                                </p>




                            </div>

                            <div className={styles.school_ritual_img_box_wrpr}>

                                <img
                                    className={styles.school_ritual_img1}
                                    src="/image/jupiter_img_3_new.webp" alt='Image'
                                />

                                {/* <img className={styles.abs_img1} src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/saturn-jupiter-venus-mars-mercury-img/jupiter_img_2_glow.webp" alt='Image' /> */}

                            </div>

                        </div>





                    </div>

                </div>
            </LazySection>

            <LazySection >


                <div className={`${styles.saturn_archetype_Block1} `} >

                    <div className={styles.common_width}>
{/* 
                        <div className={styles.column}>
                            <div className={`${styles.col12} ${styles.bgifive}`}>
                                <h2>
                                    The Saturn Archetype - Divine Intelligence
                                </h2>
                            </div>
                        </div> */}




                        <div className={`${styles.saturn_archetype_Block1_Innr} ${styles.flx_wrpr} `}>

                            <div className={styles.school_ritual_txt_box_wrpr}>
                                <h2 ref={theSaturnArchetype}>Saturn Invocation</h2>
                                <h6>The Saturn Archetype - Divine Intelligence</h6>
                                <h3>1. Overcoming Limitations and Fears</h3>

                                <p>By consciously banishing traits like limitations, fears, pessimism, and rigidity, you open yourself to the possibility of growth beyond your current boundaries. This purification helps you approach life's challenges with a more optimistic and flexible mindset, enhancing your ability to tackle obstacles effectively. </p>

                                <h3>2. Building Structure and Discipline</h3>


                                <p>Invoking Saturn’s qualities such as structure, discipline, and responsibility solidifies your foundation for achieving long-term goals. As these traits are strengthened, you develop a robust framework within which you can operate more efficiently, enhancing both personal and professional growth.
                                </p>

                                <h3>3. Cultivating Endurance and Patience</h3>


                                <p>Saturn influences daily activities that involve long-term planning and dealing with authority figures. By establishing routines and embracing responsibilities, you harness Saturn’s energy of endurance and patience, key elements for achieving sustained success and navigating complex systems.

                                </p>

                               


                            </div>

                            <div className={styles.school_ritual_img_box_wrpr}>

                                <img
                                    className={styles.school_ritual_img1}
                                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/saturn-jupiter-venus-mars-mercury-img/saturn_img_1.webp" alt='Image'
                                />

                            </div>

                        </div>





                    </div>

                </div>
            </LazySection>

            <LazySection >

                <div className={`${styles.saturn_archetype_Block2} `} >

                    <div className={styles.common_width}>

                        <div className={`${styles.saturn_archetype_Block2_Innr} ${styles.flx_wrpr} ${styles.flx_row}`}>

                            <div className={styles.school_ritual_txt_box_wrpr}>
                                <h3>4. Lessons Learned and Wisdom Gained</h3>


                                <p>Engaging in reflection on past experiences and lessons learned allows you to make wiser decisions moving forward. This practice connects you deeply with Saturn’s role as the teacher of hard-won lessons, enabling you to apply this wisdom in practical and meaningful ways.
                                </p>

                                <h3>5. Achievement of Long-Term Goals</h3>


                                <p>By setting long-term goals and methodically working towards them, you embody Saturn’s qualities of perseverance and responsibility. This not only impacts your personal ambitions but also inspires and instills a sense of reliability and trustworthiness in those around you, fostering a reputation for integrity and diligence.
                                </p>

                                <p>Through this ritual praxis, you refine your ability to perceive and integrate the archetypal power of Saturn directly. This integration results in a transformative effect on your capacity to organize, plan, and persevere, leading to significant achievements and a more disciplined approach to life's challenges.
                                </p>


                            </div>

                            <div className={styles.school_ritual_img_box_wrpr}>

                                <img
                                    className={styles.school_ritual_img1}
                                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/saturn-jupiter-venus-mars-mercury-img/saturn_imgg_2.webp" alt='Image'
                                />

                            </div>

                        </div>





                    </div>

                </div>
            </LazySection>

            <LazySection >

                <div className={`${styles.saturn_archetype_Block3} `} >

                    <div className={styles.common_width}>

                        <div className={`${styles.saturn_archetype_Block3_Innr} ${styles.flx_wrpr} `}>

                            <div className={styles.school_ritual_txt_box_wrpr}>
                                <h3>Ritual Praxis of the Planetary Intelligence</h3>

                                <p>Once completing the opening of the gates of earth, staying still and centralized within the ritual space,
                                    focusing on the infinite center of being and the spherical self boundary as the total immortal and
                                    infinite self, make the gesture of Saturn. Hold for one to three full breaths then make the pronouncement and resonate the Divine Name of the Planetary Intelligence.

                                </p>

                                <p><span>Pronouncement: "In nomine Saturni, magistri temporis et disciplinae,"</span>

                                </p>

                                <p><span>Translation: "In the name of Saturnus, master of time and discipline,"</span> </p>

                                <p><span>Phonetics: "In noh-mee-nay Sah-toor-nee, mah-gis-tree tem-poh-rees et dee-sci-plee-neh,"</span></p>

                                <div className={styles.clippathsec}>
                                    <p>Resonate Divine Name <span>(1 to 3 times)</span></p>
                                </div>

                                <p style={{ fontWeight: "500" }}><span className={styles.color_white}>Saturn / Latin:</span> <span> Saturnus (sah-TOOR-noos) - saaaaaah-TOOOOOR-nooooos</span></p>

                                <p>If banishing, focus on a purification of Saturn’s Archetype within the personal psychology and energetic being. If invoking, focus on the unity between the self and the self boundary as a total unity allowing the Divine Intelligence of the Higher Being of Saturn to possess and transform.  Hold the sign of
                                    silence for at least three full breaths afterward focusing on the purity of the Archetype if Banishing or allowing the Planetary Intelligence to fully embody if Invoking.
                                </p>




                            </div>

                            <div className={styles.school_ritual_img_box_wrpr}>

                                <img
                                    className={styles.school_ritual_img1}
                                    src="/image/saturn_img_3_new.webp" alt='Image'
                                />

                            </div>

                        </div>





                    </div>

                </div>
            </LazySection>
        </>
    )
}

export default BlockFive
